import '../../App.css';
import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';

function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL ;
  const uploadUrl=process.env.REACT_APP_FOR_UPLOADS_URL
  useEffect(() => {
    setLoading(true);
fetch(`${apiUrl}/api/posts`)
      .then(res => res.json())
      .then(data => {
        setPosts(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching posts:', err);
        setLoading(false);
      });
  }, []);

  const scrollArticles = (direction) => {
    const container = document.getElementById('recentArticlesScroll');
    if (container) {
      container.scrollBy({
        left: direction === 'left' ? -300 : 300,
        behavior: 'smooth'
      });
    }
  };

  // Calculate reading time based on content length
  const calculateReadingTime = (content) => {
    const wordsPerMinute = 200;
    const textContent = content.replace(/<[^>]*>/g, ''); // Strip HTML tags
    const wordCount = textContent.split(/\s+/).length;
    const readingTime = Math.ceil(wordCount / wordsPerMinute);
    return readingTime < 1 ? 1 : readingTime;
  };

  // Format content for preview by preserving HTML structure
  const formatContentPreview = (content, maxLength) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;
    
    const textContent = tempDiv.textContent || tempDiv.innerText;
    
    if (textContent.length <= maxLength) {
      return content;
    }
    
    // Find a good breakpoint (end of sentence or paragraph)
    let breakpoint = maxLength;
    const goodBreakpoints = ['. ', '! ', '? ', '</p>'];
    
    for (let i = maxLength; i >= maxLength / 2; i--) {
      for (const bp of goodBreakpoints) {
        if (textContent.substring(i - bp.length, i) === bp) {
          breakpoint = i;
          break;
        }
      }
    }
    
    return textContent.substring(0, breakpoint) + '...';
  };

  // Format date to readable format
  const formatDate = (dateString) => {
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const featured = posts[0];
  const recent = posts.slice(1, 7);
  const heroMessages = [
   {
    /* 1 */
    title: "Master the U.S. Admissions Maze—Insider Strategies Await",
    subtitle:
      "Discover step-by-step guides on SAT/ACT prep, Common App secrets, and Ivy-level personal-statement tips. Turn daunting U.S. applications into a streamlined success plan with Admissions Express."
  },
  {
    /* 2 */
    title: "From Acceptance Letter to Campus Life—Your U.S. Journey Starts Here",
    subtitle:
      "Unpack housing hacks, health-insurance must-knows, and first-week cultural cues. We walk you through scholarship searches, orientation prep, and everything in between so you land ready to thrive."
  },
  {
    /* 3 */
    title: "Visa Victory & Scholarships—Your Complete Study-USA Playbook",
    subtitle:
      "Navigate the DS-160, ace your visa interview, and unlock funding opportunities other students miss. Our experts translate government jargon into clear action items that keep your dream on track."
  },
  {
    /* 4 */
    title: "Real Stories, Real Success—Students Conquering the American Dream",
    subtitle:
      "Read firsthand journeys from Admissions Express scholars who turned 4.0 GPAs, athletics, or artistic flair into full-ride offers at top U.S. universities. Get their hard-won tips and motivation."
  },
  {
    /* 5 */
    title: "Dream, Apply, Fly—Your Roadmap to Studying in the USA",
    subtitle:
      "From choosing majors that open OPT career doors to finding the perfect campus culture, our blog equips you with data-driven insights and actionable checklists for every milestone."
  }
  ];

  const [selectedHero, setSelectedHero] = useState(heroMessages[0]);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * heroMessages.length);
    setSelectedHero(heroMessages[randomIndex]);
  }, []);


  return (
    <>
         <div className="blog-hero-section">
      <div className="blog-hero-overlay">
        <div className="blog-hero-content">
          <h1 className="blog-hero-title">{selectedHero.title}</h1>
          <p className="blog-hero-subtitle">{selectedHero.subtitle}</p>
          <a href="#recent-articles" className="blog-hero-btn">
            Explore Articles
          </a>
        </div>
      </div>
    </div>

      <div className="blog-container">
        {loading ? (
          <div className="blog-loading-container">
            <div className="blog-loading-spinner"></div>
            <p>Loading articles...</p>
          </div>
        ) : (
          <>
            {/* Featured Article */}
            {featured && (
              <section className="blog-featured-section">
                <div className="blog-featured-container">
                  <div className="blog-featured-content">
                    <div className="blog-featured-text">
                      <div className="blog-featured-meta">
                        <span className="blog-featured-badge">Featured Article</span>
                        <div className="blog-meta-info">
                          <span className="blog-date">
                            📅 {formatDate(featured.createdAt)}
                          </span>
                          <span className="blog-reading-time">
                            🕒 {calculateReadingTime(featured.content)} min read
                          </span>
                          {featured.category && (
                            <span className="blog-category">
                              📂 {featured.category}
                            </span>
                          )}
                        </div>
                      </div>
                      
                      <h1 className="blog-featured-title">{featured.title}</h1>
                      
                      <div 
                        className="blog-featured-excerpt"
                        dangerouslySetInnerHTML={{
                          __html: formatContentPreview(featured.content, 300)
                        }}
                      />
                      
<a href={`/post/${featured.slug}`} className="blog-read-more-btn">
                        Read Full Article
                        <span className="blog-btn-arrow">→</span>
                      </a>
                    </div>
                    
                    {/* Featured Image */}
                    <div className="blog-featured-image">
                      {featured.coverUrl && featured.mediaType === 'image' ? (
                        <img
                          src={`${uploadUrl}${featured.coverUrl}`}
                          alt={featured.title}
                          className="blog-featured-img"
                        />
                      ) : featured.coverUrl && featured.mediaType === 'video' ? (
                        <video
                          src={`${uploadUrl}${featured.coverUrl}`}
                          className="blog-featured-video"
                          controls
                          poster=""
                        />
                      ) : (
                        <div className="blog-featured-placeholder">
                          <div className="blog-placeholder-content">
                            <span className="blog-placeholder-icon">📰</span>
                            <p>Featured Article</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            )}

            {/* Recent Articles Section */}
            <section className="blog-recent-section" id="recent-articles">
              <div className="blog-section-header">
                <h2 className="blog-section-title">Recent Blog Posts</h2>
                <p className="blog-section-subtitle">
                  Stay updated with our latest insights and educational content
                </p>
              </div>

              <div className="blog-articles-container">
                <div id="recentArticlesScroll" className="blog-articles-wrapper">
                  {recent.map(article => (
                    <article key={article.id} className="blog-article-card">
                      {/* Article Image */}
                      <div className="blog-card-image">
                        {article.coverUrl && article.mediaType === 'image' ? (
                          <img
                            src={`${uploadUrl}${article.coverUrl}`}
                            alt={article.title}
                            className="blog-card-img"
                          />
                        ) : article.coverUrl && article.mediaType === 'video' ? (
                          <video
                            src={`${uploadUrl}${article.coverUrl}`}
                            className="blog-card-video"
                            muted
                          />
                        ) : (
                          <div className="blog-card-placeholder">
                            <span className="blog-placeholder-icon">📄</span>
                          </div>
                        )}
                      </div>
                      
                      {/* Article Content */}
                      <div className="blog-card-content">
                        <div className="blog-card-meta">
                          <span className="blog-card-date">
                            {formatDate(article.createdAt)}
                          </span>
                          <span className="blog-card-reading-time">
                            {calculateReadingTime(article.content)} min read
                          </span>
                        </div>
                        
                        <h3 className="blog-card-title">{article.title}</h3>
                        
                        {article.category && (
                          <span className="blog-card-category">{article.category}</span>
                        )}
                        
                        <div 
                          className="blog-card-excerpt"
                          dangerouslySetInnerHTML={{ 
                            __html: formatContentPreview(article.content, 120) 
                          }} 
                        />
                        
<a href={`/post/${article.slug}`} className="blog-card-btn">
                          Read Article
                          <span className="blog-btn-arrow">→</span>
                        </a>
                      </div>
                    </article>
                  ))}
                </div>

                {/* Carousel Controls */}
                <div className="blog-carousel-controls">
                  <button 
                    className="blog-carousel-btn blog-carousel-prev"
                    onClick={() => scrollArticles('left')}
                    aria-label="Previous articles"
                  >
                    ←
                  </button>
                  <button 
                    className="blog-carousel-btn blog-carousel-next"
                    onClick={() => scrollArticles('right')}
                    aria-label="Next articles"
                  >
                    →
                  </button>
                </div>
              </div>
            </section>
          </>
        )}
      </div>
    
      <Footer />
    </>
  );
}

export default BlogPage;